import { render, staticRenderFns } from "./PasswordResetConfirm.vue?vue&type=template&id=77196643"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77196643')) {
      api.createRecord('77196643', component.options)
    } else {
      api.reload('77196643', component.options)
    }
    module.hot.accept("./PasswordResetConfirm.vue?vue&type=template&id=77196643", function () {
      api.rerender('77196643', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/auth/views/PasswordResetConfirm.vue"
export default component.exports